import {
  pivotActionLabel,
  pivotCleanTarget,
  pivotLaunchTitle,
  resolvePivotKind,
} from '../components/investigation/TargetPivotsCard';

/**
 * Prefer a company pivot that matches the inspected row; else first company pivot.
 *
 * @param {object|null|undefined} row
 * @param {object[]} pivots
 * @returns {object|null}
 */
export function pickInspectCorporatePivot(row, pivots = []) {
  const list = Array.isArray(pivots) ? pivots : [];
  const company = list.filter((p) => resolvePivotKind(p) === 'company');
  if (!company.length) return null;

  const hay = [
    row?.title,
    row?.display_name,
    row?.snippet,
    row?.url,
    row?.domain,
    row?.details?.domain,
    row?.details?.primary_brand,
    row?.target_entity,
  ]
    .map((x) => String(x || '').toLowerCase())
    .join(' ');

  const matched = company.find((p) => {
    const domain = String(p?.domain || '').toLowerCase();
    const label = String(p?.label || p?.company_name || '').toLowerCase();
    const query = String(p?.query || '').toLowerCase();
    return (
      (domain && hay.includes(domain)) ||
      (label && label.length > 2 && hay.includes(label)) ||
      (query && hay.includes(query))
    );
  });

  return matched || company[0];
}

/**
 * Copy for inspect-drawer quick pivot CTA.
 *
 * @param {object} pivot
 * @returns {{ label: string, title: string, target: string }}
 */
export function inspectCorporatePivotCopy(pivot) {
  const target = pivotCleanTarget(pivot) || 'Corporate';
  return {
    label: 'Pivot to Corporate',
    title: pivotLaunchTitle(pivot) || `Launch Corporate Search for: ${target}`,
    target,
    scanLabel: pivotActionLabel(pivot),
  };
}
